"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MarketplaceCXIdMappingClientImpl_1 = __importDefault(require("./MarketplaceCXIdMappingClientImpl"));
var MarketplaceCXIdMappingClientProvider = /** @class */ (function () {
    function MarketplaceCXIdMappingClientProvider() {
        this.CONTEXTUAL_PARAMETERS = ["acs_marketplace_id"];
        this.STAGE_VERSION_LABEL_NAME = "AcsMarketplaceCXIdMapping";
        this.TABLE_NAME = "acs_MarketplaceCXIdMapping";
    }
    MarketplaceCXIdMappingClientProvider.prototype.createTypeSafeClient = function (configSet) {
        return new MarketplaceCXIdMappingClientImpl_1.default(configSet);
    };
    return MarketplaceCXIdMappingClientProvider;
}());
exports.default = MarketplaceCXIdMappingClientProvider;
